<template>
	<div v-if="results && results.length">	
		<div
			class="cetin-vysledek-card zmensit"
			v-for="(b, index) of results"
			:key="index"
		>
			{{ b }}
		</div>
	</div>
</template>

<script>
export default {
	name: 'CetinBondingResult',

	props: {
		results: { type: Array },
	},

}
</script>

<style lang="stylus" scoped>
.cetin-vysledek-card
	padding 10px
	background-color white
	border-radius 5px
	margin-right 10px
	margin-bottom 10px

.zmensit
	width 400px

.loading
	height 50px
	padding 0px

.loading-icon
	height 50px
	padding 0px !important
	margin-top -100px !important

@media (max-width 1000px)
	.zmensit
		width 100%

</style>



// WEBPACK FOOTER //
// src/components/search_provider/results/CetinBondingResult.vue